import Raven from 'raven-js';
const git = require('../server/hash.json');

Raven.config(
  process.env.NODE_ENV === 'production' &&
    'https://2d461888fa0c406581064e06ebe1f718@sentry.io/227021',
  {
    name: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    environment: process.env.REACT_APP_ENV,
    release: git.hash,
    autoBreadcrumbs: true,
    maxBreadcrumbs: 3,
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage'
    ],
    ignoreUrls: [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /127\.0\.0\.1:4001\/isrunning/i,
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ]
  }
).install();

export default Raven;



// WEBPACK FOOTER //
// ./src/services/raven.js